
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Image';